import Vue, { type CreateElement } from 'vue';
import { Fragment } from 'vue-frag';
import vSelect from 'vue-select';
// @ts-ignore TS2307: Cannot find module 'vue-typeahead-bootstrap' or its corresponding type declarations.
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import { Link } from '@inertiajs/inertia-vue';

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

Vue.component('Fragment', Fragment);
Vue.component('VSelect', vSelect);
Vue.component('VueTypeahead', VueTypeaheadBootstrap);
// @ts-ignore Argument of type 'InertiaLink' is not assignable
Vue.component('InertiaLink', Link);

// @ts-ignore https://vue-select.org/guide/components.html#setting-globally-at-registration
vSelect.props.label.default = 'name';
// @ts-ignore TS2339: Property 'default' does not exist on type 'boolean'.
vSelect.props.clearable.default = false;
// @ts-ignore
vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: (createElement: CreateElement) =>
      createElement('span', {
        domProps: {
          innerHTML:
            '<svg width="16" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m15 1.5-7 7-7-7" stroke="#0000C9" stroke-width="2" /></svg>',
        },
      }),
  },
  Deselect: {
    render: (createElement: CreateElement) =>
      createElement('span', {
        class: 'vs__deselect-indicator',
      }),
  },
});
